import React, { FC, ReactNode } from 'react';
import { MotifTooltip } from '@ey-xd/motif-react';

type TooltipProps = {
    id?: string | number;
    variant?: 'default' | 'alt';
    trigger?: ReactNode;
    placement?: 'auto' | 'top' | 'right' | 'bottom' | 'left';
    contentClassName?: string;
    flip?: boolean;
    hide?: boolean;
    allowClick?: boolean;
    allowHover?: boolean;
    closeButtonProps?: object;
    forceHideCounter?: number;
    hideCloseButton?: boolean;
    hideArrow?: boolean;
    className?: string;
    children?: React.ReactNode | string;
    style?: any;
};
const Tooltip: FC<TooltipProps> = ({ className, allowHover, ...other }: TooltipProps) => (
    <MotifTooltip className={className} allowHover={allowHover} {...other} />
);
export default Tooltip;
